export default function registerFavoritesStore(Alpine) {
    Alpine.store('favorites', {
        counts: {
            favorite: 0,
            compare: 0,
        },

        items: {
            favorite: [],
            compare: [],
        },

        set(type, count) {
            this.counts[type] = Number(count) || 0;
        },

        has(productId, type = 'favorite') {
            return this.items[type]?.includes(productId);
        },

        async toggle(productId, type = 'favorite') {
            const app = Alpine.store('app');

            const res = await fetch(app.routes.favorites.toggle, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': app.csrf,
                    'Accept': 'application/json',
                },
                body: JSON.stringify({ product_id: productId, type }),
            });

            const data = await res.json();
            if (!res.ok) throw data;

            this.counts[type] = data.count;

            if (data.added) {
                this.items[type].push(productId);
            } else {
                this.items[type] = this.items[type].filter(id => id !== productId);
            }

            return data.added;
        },

        init(state) {
            if (!state) return;

            this.set('favorite', state.counts?.favorite);
            this.set('compare', state.counts?.compare);
            this.items = state.items ?? {
                favorite: [],
                compare: [],
            };
        },
    });
}
